import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Save, Send } from 'lucide-react';
import { 
  interventions as interventionsData,
  centres,
  typesIntervention,
  getTechniciens 
} from '../../data/mockData';

function FormulaireIntervention({ user }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;
  
  const techniciens = getTechniciens();

  const [formData, setFormData] = useState({
    centreId: '',
    technicienId: '',
    typeInterventionId: '',
    plaque: '',
    datePrevu: new Date().toISOString().split('T')[0],
    heurePrevu: '09:00',
    commentaire: '',
  });

  const [selectedType, setSelectedType] = useState(null);

  useEffect(() => {
    if (isEditing) {
      const intervention = interventionsData.find(i => i.id === parseInt(id));
      if (intervention) {
        setFormData({
          centreId: intervention.centreId,
          technicienId: intervention.technicienId,
          typeInterventionId: intervention.typeInterventionId,
          plaque: intervention.plaque,
          datePrevu: intervention.datePrevu,
          heurePrevu: intervention.heurePrevu,
          commentaire: intervention.commentaire || '',
        });
        
        const type = typesIntervention.find(t => t.id === intervention.typeInterventionId);
        setSelectedType(type);
      }
    }
  }, [id, isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name.includes('Id') ? parseInt(value) : value
    }));

    if (name === 'typeInterventionId') {
      const type = typesIntervention.find(t => t.id === parseInt(value));
      setSelectedType(type);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const nouvelleIntervention = {
      ...formData,
      dureeEstimee: selectedType?.dureeEstimee || 60,
      statut: 'planifiee',
      creeLe: new Date().toISOString(),
      creePar: user.id,
    };

    console.log('Intervention sauvegardée:', nouvelleIntervention);
    
    navigate('/interventions');
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <button onClick={() => navigate('/interventions')} className="btn-back">
            <ArrowLeft size={20} />
            Retour
          </button>
          <h1>{isEditing ? 'Modifier l\'intervention' : 'Nouvelle intervention'}</h1>
        </div>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="form-card">
          <div className="form-section">
            <h2>Informations de l'intervention</h2>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="centreId">Centre *</label>
                <select
                  id="centreId"
                  name="centreId"
                  value={formData.centreId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez un centre</option>
                  {centres.filter(c => c.actif).map(centre => (
                    <option key={centre.id} value={centre.id}>
                      {centre.nom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="technicienId">Technicien *</label>
                <select
                  id="technicienId"
                  name="technicienId"
                  value={formData.technicienId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez un technicien</option>
                  {techniciens.map(tech => (
                    <option key={tech.id} value={tech.id}>
                      {tech.prenom} {tech.nom}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="typeInterventionId">Type d'intervention *</label>
                <select
                  id="typeInterventionId"
                  name="typeInterventionId"
                  value={formData.typeInterventionId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez un type</option>
                  {typesIntervention.filter(t => t.actif).map(type => (
                    <option key={type.id} value={type.id}>
                      {type.code} - {type.libelle}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="plaque">Numéro de plaque *</label>
                <input
                  type="text"
                  id="plaque"
                  name="plaque"
                  value={formData.plaque}
                  onChange={handleChange}
                  placeholder="AB-123-CD"
                  required
                />
              </div>
            </div>

            {selectedType && (
              <div className="info-box info-primary">
                <p><strong>Durée estimée :</strong> {selectedType.dureeEstimee} minutes</p>
                <p className="text-sm">{selectedType.description}</p>
              </div>
            )}
          </div>

          <div className="form-section">
            <h2>Planification</h2>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="datePrevu">Date prévue *</label>
                <input
                  type="date"
                  id="datePrevu"
                  name="datePrevu"
                  value={formData.datePrevu}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="heurePrevu">Heure prévue *</label>
                <input
                  type="time"
                  id="heurePrevu"
                  name="heurePrevu"
                  value={formData.heurePrevu}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="commentaire">Commentaire interne (optionnel)</label>
              <textarea
                id="commentaire"
                name="commentaire"
                value={formData.commentaire}
                onChange={handleChange}
                rows="3"
                placeholder="Informations complémentaires pour le technicien..."
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={() => navigate('/interventions')} className="btn btn-secondary">
              Annuler
            </button>
            <button type="submit" className="btn btn-primary">
              <Save size={20} />
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormulaireIntervention;

